<div class="product-direct-select">
  <label for="productDirectSelect" class="admin-field-label">Productos disponibles</label>
  <ng-select
    id="productDirectSelect"
    class="admin-ng-select product-direct-select__ng w-100"
    [items]="products()"
    [ngModel]="value"
    (ngModelChange)="onSelect($event)"
    [ngModelOptions]="{standalone: true}"
    [disabled]="disabled"
    [bindLabel]="bindLabel()"
    placeholder="Seleccione producto"
    [searchable]="true"
    notFoundText="No se encontraron productos"
    appendTo="body"
    [class.is-invalid]="!value && !disabled">
    <ng-template ng-label-tmp let-item="item">
      <div class="product-direct-select__option">
        <div class="product-direct-select__title">{{ getLabel(item) }}</div>
        @if (item?.delivery_badges?.length) {
          <div class="product-direct-select__badges">
            @for (badge of item.delivery_badges; track badge.label) {
              <span
                class="product-direct-select__badge"
                [class.product-direct-select__badge--disabled]="!badge.available">
                {{ badge.label }}
              </span>
            }
          </div>
        }
      </div>
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
      <div class="product-direct-select__option">
        <div class="product-direct-select__title">{{ getLabel(item) }}</div>
        @if (item?.delivery_badges?.length) {
          <div class="product-direct-select__badges">
            @for (badge of item.delivery_badges; track badge.label) {
              <span
                class="product-direct-select__badge"
                [class.product-direct-select__badge--disabled]="!badge.available">
                {{ badge.label }}
              </span>
            }
          </div>
        }
      </div>
    </ng-template>
  </ng-select>
  @if (showDescription() && value?.description) {
    <p class="mt-2 mb-0">{{ value.description }}</p>
  }
</div>
